import { ReactNode } from 'react';
import { Modal } from 'reactstrap';

interface Props {
  isOpen: boolean;
  onToggle: () => void;
  titleText: string;
  children?: ReactNode;
  size?: 'sm' | 'lg' | 'xl';
}

const SimpleModal = ({
  isOpen,
  onToggle,
  titleText,
  children,
  size = 'sm',
}: Props) => {
  return (
    <Modal
      className="modal-dialog-centered"
      isOpen={isOpen}
      toggle={() => onToggle()}
      size={size}
    >
      <div className="modal-header">
        <h6 className="modal-title" id="modal-title-default">
          {titleText}
        </h6>
        <button
          aria-label="Close"
          className="close"
          data-dismiss="modal"
          type="button"
          onClick={() => onToggle()}
        >
          <span aria-hidden={true}>×</span>
        </button>
      </div>

      <div className="modal-body"> {children}</div>
    </Modal>
  );
};

export default SimpleModal;
